import { EAdmissionStages, TAdmissionStages } from "../modals/admissions";

export const AdmissionStagesAPI: TAdmissionStages = {
      [EAdmissionStages.criteria_selection]: {
            url: '/application/createApplication',
            method: 'post',
            getUrl: ''
      },
      [EAdmissionStages.payment]: {
            url: '/application/createApplication',
            method: 'post',
            getUrl: ''
      },
      [EAdmissionStages.basic_details]: {
            url: '/user/update',
            method: 'put',
            getUrl: '/user',
      },
      [EAdmissionStages.educational_details]: {
            url: '/user/update',
            method: 'put',
            getUrl: '/user',
      },
      [EAdmissionStages.experience_professional]: {
            url: '/user/update',
            method: 'put',
            getUrl: '/user',
      },
      [EAdmissionStages.applications]: {

            url: '/user/update',
            method: 'put',
            getUrl: '/user',
      },
      [EAdmissionStages.upload_documents]: {
            url: '',
            method: 'post',
            getUrl: '/file/list',
      },
}